<template>
    <div class="bg-white px-3 index" >
        <div class="add_tits" ref="titles">
            <el-form class="form-inlines " :inline="true">
                <div class="u-f u-ac u-jsb">
                    <el-form-item>
                        <el-button type="primary" icon="el-icon-search" size="small" @click="begin">搜索</el-button>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" icon="el-icon-circle-plus-outline" size="small" @click="handleAdd">新增
                        </el-button>
                    </el-form-item>
                </div>
            </el-form>
        </div>
        <div class="ibox-content">
            <el-table :data="tableData" :height="height" border v-loading="loading">
                <el-table-column prop="id" label="编号" width="70"></el-table-column>
                <el-table-column prop="action" label="类别"></el-table-column>
                <el-table-column prop="requirement" label="任务要求" show-overflow-tooltip></el-table-column>
                <el-table-column prop="medal_name" label="勋章名称"></el-table-column>
                <el-table-column label="操作" width="130" align="center">
                    <template slot-scope="scope">
                        <el-button size="mini" type="primary" icon="el-icon-edit-outline"
                            @click="handleEdit(scope.row,scope.$index)"></el-button>
                        <el-button size="mini" type="danger" icon="el-icon-delete"
                            @click="handleDelet(scope.row,scope.$index)"></el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="u-f u-ac u-jsb ft_mr">
                <div></div>
                <div>
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                        :current-page="currentPage" :page-sizes="[10, 30, 50, 100]" :page-size="pagesize"
                        layout="total, sizes, prev, pager, next, jumper" :total="count">
                    </el-pagination>
                </div>
            </div>

        </div>
        <el-dialog title="会员设置" :visible.sync="dialogVisible" center top="20px" class="dialogs">
            <el-divider></el-divider>
            <div class="dialog-ibox-content">
                <el-form :model="ruleForm" :rules="rule" ref="ruleForm" label-width="150px" class="demo-ruleForm">
                    <el-form-item label="类别" prop='action'>
                        <el-input v-model="ruleForm.action" size="small" class="gg_wid"></el-input>
                    </el-form-item>
                    <el-form-item label="任务要求" prop='requirement'>
                        <el-input v-model="ruleForm.requirement" size="small" class="gg_wid"></el-input>
                    </el-form-item>
                    <el-form-item label="勋章名称" prop='medal_name'>
                        <div class="u-f u-ac u-jsb">
                            <div style="flex:1">
                                <el-input v-model="ruleForm.medal_name" size="small" class="gg_wid"></el-input>
                            </div>
                            <div>
                                <el-button icon="el-icon-circle-plus-outline" size="small" type="primary"
                                    @click="handleAdds">新增</el-button>
                            </div>
                        </div>
                    </el-form-item>
                    <div v-for="(item,index) in ruleForm.list" :key="index" class="gg_box">
                        <el-form-item label="名称" :prop="`list.${index}.name`" :rules="rule.name">
                            <div class="u-f u-ac u-jsb">
                                <el-input v-model="item.name" size="small" class="gg_wid"></el-input>
                                <div class="wtsc">
                                    <el-button icon="el-icon-delete" size="small" type="danger" @click="delxx(index)"
                                        v-if="index>0">删除信息</el-button>
                                </div>
                            </div>
                        </el-form-item>
                        <el-form-item label="等级" :prop="`list.${index}.level`" :rules="rule.level">
                            <el-input placeholder="请输入等级" v-model="item.level" class="gg_wid"></el-input>
                        </el-form-item>
                        <el-form-item label="要求值" :prop="`list.${index}.required_value`" :rules="rule.required_value">
                            <el-input v-model="item.required_value" size="small" placeholder="请输入要求值" class="gg_wid">
                            </el-input>
                        </el-form-item>
                        <el-form-item label="内容">
                            <el-input type="textarea" :rows="3" placeholder="请输入内容" v-model="item.remark"
                                class="gg_wid"></el-input>
                        </el-form-item>
                    </div>

                </el-form>
            </div>
            <el-divider></el-divider>
            <span slot="footer" class="dialog-footer">
                <el-button @click="submit('ruleForm')" size="small" type="primary" :loading="subloading">提 交</el-button>
                <el-button @click="dialogVisible = false" size="small">取 消</el-button>
            </span>
        </el-dialog>

    </div>
</template>


<script>
    import {
        mapState
    } from 'vuex'
    export default {
        data() {
            return {
                loading: false,
                tableData: [],
                lb_options: [],
                currentPage: 1,
                pagesize: 15,
                count: 0,
                height: null,
                // 
                eid: '',
                dialogVisible: false,
                subloading: false,
                ruleForm: {
                    action: '',
                    requirement: '',
                    medal_name: '',
                    list: [{
                        name: '',
                        level: '',
                        required_value: '',
                        remark: '',
                    }]
                },
                rule: {
                    action: [{
                        required: true,
                        message: '请填写类别',
                        trigger: 'blur'
                    }],
                    requirement: [{
                        required: true,
                        message: '请填写任务要求',
                        trigger: 'blur'
                    }],
                    medal_name: [{
                        required: true,
                        message: '请填写勋章名称',
                        trigger: 'blur'
                    }],
                    name: [{
                        required: true,
                        message: '请填写名称',
                        trigger: 'blur'
                    }],
                    level: [{
                        required: true,
                        message: '请填写等级',
                        trigger: 'blur'
                    }],
                    required_value: [{
                        required: true,
                        message: '请填写要求值',
                        trigger: 'blur'
                    }]
                }
            };
        },
        computed: {
            ...mapState({
                user: state => state.user.user,
            })
        },
        mounted() {
            let that = this
            that.getHeight()
            that.begin()
        },
        methods: {
            getHeight() {
                let that = this
                var titles = that.$refs.titles.offsetHeight
                that.height = window.innerHeight - titles - 220 + 'px'
                window.onresize = () => {
                    var titles = that.$refs.titles.offsetHeight
                    that.height = window.innerHeight - titles - 220 + 'px'
                }
            },
            // 搜索
            begin() {
                let that = this
                that.currentPage = 1
                that.pagesize = 15
                that.search()
            },
            search() {
                let that = this
                that.loading = true
                axios.post("/admin/pc/MedalRule/medalRuleList", {
                        page: this.currentPage,
                        page_count: that.pagesize
                    }, {
                        token: true
                    })
                    .then(response => {
                        that.loading = false
                        that.tableData = response.data.data.list
                        that.count = response.data.data.count
                    })
                    .catch(error => {})
            },
            handleSizeChange(val) {
                let that = this
                that.pagesize = val;
                that.search()
            },
            handleCurrentChange(val) {
                let that = this
                that.currentPage = val;
                that.search()
            },
            handleAdd() {
                let that = this
                that.dialogVisible = true
                that.eid = ''
                that.form_clear()
            },
            form_clear() {
                let that = this
                that.ruleForm = {
                    action: '',
                    requirement: '',
                    medal_name: '',
                    list: [{
                        name: '',
                        level: '',
                        required_value: '',
                        remark: '',
                    }]
                }
            },
            handleAdds() {
                 let that = this
                that.ruleForm.list.push({
                    name: '',
                    level: '',
                    required_value: '',
                    remark: '',
                })
            },
            delxx(index){
                this.ruleForm.list.splice(index, 1)
            },
            submit(formName) {
                let that = this
                that.$refs[formName].validate((valid) => {
                    if (valid) {
                        that.subloading = true
                        let urls;
                        if (this.eid) {
                            urls = "/admin/pc/MedalRule/editMedalRule"
                        } else {
                            urls = "/admin/pc/MedalRule/addMedalRule"
                        }
                        axios.post(urls, {
                                id: that.eid,
                                action:that.ruleForm.action,
                                requirement:that.ruleForm.requirement,
                                medal_name:that.ruleForm.medal_name,
                                medal_level:that.ruleForm.list
                            }, {
                                token: true
                            })
                            .then(response => {
                                that.subloading = false
                                if (response.data.code == '200') {
                                    that.dialogVisible = false
                                    that.search()
                                    that.$message({
                                        message: '操作成功',
                                        type: 'success'
                                    });
                                } else {
                                    that.$message.error(response.data.msg);
                                }
                            })
                            .catch(error => {
                                that.subloading = false
                            })
                    } else {
                        return false;
                    }
                });
            },
            // 编辑
            handleEdit(row, index) {
                let that = this
                that.form_clear()
                that.dialogVisible = true
                that.eid = row.id
                axios
                    .post("/admin/pc/MedalRule/medalRuleInfo", {
                        id: that.eid,
                    }, {
                        token: true
                    })
                    .then(response => {
                        var data = response.data.data
                        that.ruleForm.action=data.action,
                        that.ruleForm.requirement=data.requirement
                        that.ruleForm.medal_name=data.medal_name
                        that.ruleForm.list=data.medal_level
                    })
                    .catch(error => {})
            },
            // 删除
            handleDelet(row, index) {
                let that = this
                this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    axios
                        .post("/admin/pc/MedalRule/delMedalRule", {
                            id: row.id,
                        }, {
                            token: true
                        })
                        .then(response => {
                            if (response.data.code == '200') {
                                this.$message({
                                    type: 'success',
                                    message: '删除成功!'
                                });
                                that.search()
                            } else {
                                that.$message.error(response.data.msg);
                            }
                        })
                        .catch(error => {})
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            }
        },

    };
</script>


<style scoped>
    .gg_box {
        border: 1px dashed rgb(204, 204, 204);
        padding: 10px 0px 10px 0;
        margin-top: 10px;
    }

    .gg_wid {
        width: 80%;
    }
</style>